import { LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class CountryLookup extends LookupBase {

    public countryId: number = 0;

    public countryName: string = "";

    // Client only properties / methods
}
